import React from 'react';
import LegalDocument, { Enlace, Filas, Resumen } from '../../components/legal/LegalLayout';

const resumen = (
  <Resumen
    titulo="En pocas palabras"
    items={[
      ['Qué se usa', 'Solo lo imprescindible para que la web funcione y recuerde tus preferencias.'],
      ['Qué no se usa', 'Analítica, publicidad, píxeles de redes sociales ni rastreo de terceros.'],
      ['Consentimiento', 'No hace falta pedirlo, por eso no verás ningún banner (art. 22.2 LSSI-CE).'],
    ]}
  />
);

const secciones = [
  {
    id: 'detalle',
    titulo: 'Qué se guarda en tu navegador',
    contenido: (
      <Filas
        etiqueta="Cookies y almacenamiento"
        columnas={['Nombre', 'Para qué sirve', 'Tipo', 'Duración']}
        filas={[
          ['DIEGONCURSO_SESSION', 'Mantener tu sesión iniciada.', 'Cookie propia, técnica', '30 días desde tu última visita o hasta cerrar sesión'],
          ['theme', 'Recordar si prefieres el modo claro u oscuro.', 'Almacenamiento local, preferencia', 'Hasta que lo borres'],
          ['userData, adminToken', 'Datos básicos de sesión para pintar la interfaz.', 'Almacenamiento local, técnico', 'Hasta cerrar sesión'],
          ['estadoConcurso', 'Sincronizar el concurso en curso entre pestañas del presentador.', 'Almacenamiento local, técnico', 'Hasta que termine el concurso'],
          ['preguntasConcurso, concurso_id y similares', 'Conservar el concurso que estás preparando o jugando.', 'Almacenamiento de sesión, técnico', 'Hasta cerrar la pestaña'],
          ['Caché de la aplicación', 'Cargar más rápido y poder instalar la web como app.', 'Service worker, técnico', 'Hasta la siguiente actualización'],
        ]}
      />
    ),
  },
  {
    id: 'terceros',
    titulo: 'Servicios de terceros',
    contenido: (
      <p>
        Los iconos de redes sociales son enlaces normales y no cargan nada de esas plataformas hasta que haces clic.
        Las fotos de los concursantes se sirven desde la propia web, así que tampoco conectan tu navegador con otros
        servicios. Si algún día se añade algo que use cookies no técnicas, como analítica o vídeos incrustados, se te
        pedirá permiso antes de activarlo.
      </p>
    ),
  },
  {
    id: 'gestionar',
    titulo: 'Cómo borrarlas',
    contenido: (
      <p>
        Puedes borrar o bloquear las cookies y el almacenamiento local desde los ajustes de privacidad de tu
        navegador. Si bloqueas la cookie de sesión no podrás iniciar sesión, aunque sí ver la parte pública. Más
        detalles sobre tus datos en la <Enlace to="/privacidad">política de privacidad</Enlace>.
      </p>
    ),
  },
];

const PoliticaCookiesPage = () => (
  <LegalDocument
    titulo="Política de cookies"
    intro="Qué guarda Diegoncurso en tu navegador y por qué no necesita pedirte permiso."
    resumen={resumen}
    secciones={secciones}
  />
);

export default PoliticaCookiesPage;
